import { ReactElement, ReactNode } from 'react';
import cn from '../../utils/classnames';
import './material-label.scss';

export type MaterialLabelVariant = 'dark-green' | 'red' | 'cyan' | 'yellow';

type MaterialLabelProps = {
    variant: MaterialLabelVariant;
    children: ReactNode;
    classNames?: string;
    'aria-describedby'?: string;
};

const MaterialLabel = ({ variant, children, classNames, ...rest }: MaterialLabelProps): ReactElement => (
    <div className={cn('material-label', `${variant}`, classNames)} {...rest}>
        <span>{children}</span>
    </div>
);

export default MaterialLabel;
